<template>
    <div>
        <top-navbar :breadcrumb="breadcrumb"></top-navbar>

        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col">
                    <degrees-crud></degrees-crud>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import DegreesCrud from './degrees/DegreesCrud';

    export default {

        components: {
            DegreesCrud
        },

        computed: {

            breadcrumb() {
                return [
                    {
                        name: this.$t('common.degrees'),
                    },
                ]
            }
        },
    }
</script>
